// TODO: 이 컴포넌트는 모달이 아닌 독립 페이지(/img-modal)로만 사용됨
// - main.tsx에서 라우트 element로 직접 렌더링되며, 팝업 윈도우용 이미지 뷰어 역할
// - 구조적으로 domains/traffic-monitoring/pages/로 이동이 적절하나, 현재는 유지
// React Core
import type React from 'react';
import { useEffect } from 'react';

// Routing
import { useLocation } from 'react-router-dom';

// Assets
// import ImgDummy from '@/assets/img/img-dummy.png';
// Config / Constants
import { URLS } from '@/shared/config/urls';
// Hooks
import useTrafficEvent from '@/shared/hooks/useTrafficEvent';

// Types
import type { TrafficEventData } from '@/shared/types/traffic-event';

const VideoModal: React.FC = () => {
  const location = useLocation();

  console.log('URLS.BACK_DSH');
  console.log(URLS.BACK_DSH);
  // http://192.168.20.37:7120/api/dsh/

  const queryParams = new URLSearchParams(location.search);
  const id: string | null = queryParams.get('id');
  console.log('id');
  console.log(id);

  useEffect(() => {
    //document.title = "이미지 팝업";
  }, []);

  const { trafficEvent } = useTrafficEvent({
    id: id || undefined,
  });

  const trafficEventData: TrafficEventData | undefined = trafficEvent;
  console.log(trafficEventData);
  return (
    <section className="w-full flex flex-col h-screen bg-center bg-blue-800 overflow-hidden">
      <div className="title3medium text-[#FEFEFE] bg-[#8EB6C8] py-[5px] px-2.5 justify-between flex-row flex items-center">
        <span>
          {trafficEventData?.site_name} / {trafficEventData?.road_name} /{' '}
          {trafficEventData?.timestamp}
        </span>
        {/* <img src={IconClose} alt="" srcset="" /> */}
      </div>
      <div className="container-video flex w-full h-full bg-[#000]">
        <img
          src={`${URLS.BACK_DSH}/common/image/${trafficEventData?.image_path}`}
          alt=""
          srcSet=""
          className="w-full h-full bg-cover bg-no-repeat object-cover"
        />
      </div>
    </section>
  );
};

export default VideoModal;
